import React from "react";
import { formatMoney, getStatusBadgeClass, getStatusLabel } from "./utils";

export default function CoursesManagerPanel({
  courses,
  coursesEnabled,
  trainerProfile,
  courseForm,
  updateCourseField,
  setCourseForm,
  resetCourseForm,
  savingCourse,
  handleSaveCourse,
  handleEditCourse,
  handleDeleteCourse,
  isAdmin,
  isAr,
  isMobile,
}) {
  function updateSection(sectionIndex, field, value) {
    setCourseForm((current) => ({
      ...current,
      sections: current.sections.map((section, index) =>
        index === sectionIndex ? { ...section, [field]: value } : section
      ),
    }));
  }

  function updateLesson(sectionIndex, lessonIndex, field, value) {
    setCourseForm((current) => ({
      ...current,
      sections: current.sections.map((section, index) =>
        index === sectionIndex
          ? {
              ...section,
              lessons: section.lessons.map((lesson, currentLessonIndex) =>
                currentLessonIndex === lessonIndex ? { ...lesson, [field]: value } : lesson
              ),
            }
          : section
      ),
    }));
  }

  function addSection() {
    setCourseForm((current) => ({
      ...current,
      sections: [
        ...current.sections,
        {
          id: 0,
          titleAr: "",
          titleEn: "",
          lessons: [
            {
              id: 0,
              titleAr: "",
              titleEn: "",
              slug: "",
              lessonType: "video",
              videoUrl: "",
              contentAr: "",
              contentEn: "",
              attachmentPath: "",
              durationSeconds: "",
              isPreview: false,
            },
          ],
        },
      ],
    }));
  }

  function removeSection(sectionIndex) {
    setCourseForm((current) => ({
      ...current,
      sections: current.sections.filter((_, index) => index !== sectionIndex),
    }));
  }

  function addLesson(sectionIndex) {
    setCourseForm((current) => ({
      ...current,
      sections: current.sections.map((section, index) =>
        index === sectionIndex
          ? {
              ...section,
              lessons: [
                ...section.lessons,
                {
                  id: 0,
                  titleAr: "",
                  titleEn: "",
                  slug: "",
                  lessonType: "video",
                  videoUrl: "",
                  contentAr: "",
                  contentEn: "",
                  attachmentPath: "",
                  durationSeconds: "",
                  isPreview: false,
                },
              ],
            }
          : section
      ),
    }));
  }

  function removeLesson(sectionIndex, lessonIndex) {
    setCourseForm((current) => ({
      ...current,
      sections: current.sections.map((section, index) =>
        index === sectionIndex
          ? {
              ...section,
              lessons: section.lessons.filter((_, currentLessonIndex) => currentLessonIndex !== lessonIndex),
            }
          : section
      ),
    }));
  }

  return (
    <div className="card border-0 shadow-sm mb-4 provider-center__panel-card">
      <div className="card-body">
        <div className="pc-section-head mb-3">
          <div className="pc-section-head__left">
            <span className="pc-icon-box pc-icon-box--green">
              <i className="bi bi-easel2" />
            </span>
            <h5 className="mb-0">{isAr ? "إدارة الكورسات" : "Manage courses"}</h5>
          </div>
          <span className="badge text-bg-light">{courses.length}</span>
        </div>

        {!coursesEnabled ? (
          <div className="alert alert-warning mb-0">
            {isAr
              ? "قسم الكورسات معطل حاليًا من الإدارة."
              : "The courses section is currently disabled from admin settings."}
          </div>
        ) : !isAdmin && !trainerProfile ? (
          <div className="text-muted">
            {isAr
              ? "أرسل طلب اعتماد كمدرب أولًا، وبعد الموافقة ستتمكن من إضافة الكورسات هنا."
              : "Apply as a trainer first. Once approved, you will be able to submit courses here."}
          </div>
        ) : !isAdmin && trainerProfile.status !== "approved" ? (
          <div className="text-muted">
            {isAr
              ? "ملف المدرب ما زال بانتظار موافقة الإدارة."
              : "Your trainer profile is still waiting for admin approval."}
          </div>
        ) : (
          <>
            <div className="alert alert-info">
              {isAr
                ? "يمكنك من هنا إرسال كورس كامل مع الأقسام والدروس. أي تعديل يعيد الكورس إلى المراجعة."
                : "You can submit a full course here with sections and lessons. Any change will send the course back to review."}
            </div>

            <form onSubmit={handleSaveCourse}>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "عنوان الكورس بالعربية" : "Title Arabic"}</label>
                  <input
                    className="form-control"
                    value={courseForm.titleAr}
                    onChange={(event) => updateCourseField("titleAr", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "عنوان الكورس بالإنجليزية" : "Title English"}</label>
                  <input
                    className="form-control"
                    value={courseForm.titleEn}
                    onChange={(event) => updateCourseField("titleEn", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "وصف مختصر بالعربية" : "Short Description Arabic"}</label>
                  <textarea
                    rows="2"
                    className="form-control"
                    value={courseForm.shortDescriptionAr}
                    onChange={(event) => updateCourseField("shortDescriptionAr", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "وصف مختصر بالإنجليزية" : "Short Description English"}</label>
                  <textarea
                    rows="2"
                    className="form-control"
                    value={courseForm.shortDescriptionEn}
                    onChange={(event) => updateCourseField("shortDescriptionEn", event.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "الوصف بالعربية" : "Description Arabic"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={courseForm.descriptionAr}
                    onChange={(event) => updateCourseField("descriptionAr", event.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "الوصف بالإنجليزية" : "Description English"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={courseForm.descriptionEn}
                    onChange={(event) => updateCourseField("descriptionEn", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "السعر" : "Price"}</label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    className="form-control"
                    value={courseForm.price}
                    onChange={(event) => updateCourseField("price", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "سعر العرض" : "Sale Price"}</label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    className="form-control"
                    value={courseForm.salePrice}
                    onChange={(event) => updateCourseField("salePrice", event.target.value)}
                    disabled={courseForm.isFree}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "المستوى" : "Level"}</label>
                  <select
                    className="form-select"
                    value={courseForm.level}
                    onChange={(event) => updateCourseField("level", event.target.value)}
                  >
                    <option value="beginner">{isAr ? "مبتدئ" : "Beginner"}</option>
                    <option value="intermediate">{isAr ? "متوسط" : "Intermediate"}</option>
                    <option value="advanced">{isAr ? "متقدم" : "Advanced"}</option>
                  </select>
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "مدة الكورس" : "Duration Text"}</label>
                  <input
                    className="form-control"
                    value={courseForm.durationText}
                    onChange={(event) => updateCourseField("durationText", event.target.value)}
                    placeholder={isAr ? "مثال: 6 ساعات" : "Example: 6 hours"}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">{isAr ? "التصنيف" : "Category"}</label>
                  <input
                    className="form-control"
                    value={courseForm.category}
                    onChange={(event) => updateCourseField("category", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-4 d-flex align-items-end gap-3">
                  <div className="form-check mb-2">
                    <input
                      id="provider-course-free"
                      type="checkbox"
                      className="form-check-input"
                      checked={courseForm.isFree}
                      onChange={(event) => updateCourseField("isFree", event.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="provider-course-free">
                      {isAr ? "كورس مجاني" : "Free course"}
                    </label>
                  </div>
                  <div className="form-check mb-2">
                    <input
                      id="provider-course-active"
                      type="checkbox"
                      className="form-check-input"
                      checked={courseForm.isActive}
                      onChange={(event) => updateCourseField("isActive", event.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="provider-course-active">
                      {isAr ? "الكورس نشط" : "Course is active"}
                    </label>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "صورة الكورس" : "Course Thumbnail"}</label>
                  <input
                    className="form-control"
                    value={courseForm.thumbnail}
                    onChange={(event) => updateCourseField("thumbnail", event.target.value)}
                    placeholder={isAr ? "رابط الصورة أو اسم الملف" : "Image URL or stored filename"}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "رابط فيديو ترويجي" : "Promo Video URL"}</label>
                  <input
                    className="form-control"
                    value={courseForm.promoVideoUrl}
                    onChange={(event) => updateCourseField("promoVideoUrl", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "المتطلبات بالعربية" : "Requirements Arabic"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={courseForm.requirementsAr}
                    onChange={(event) => updateCourseField("requirementsAr", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "المتطلبات بالإنجليزية" : "Requirements English"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={courseForm.requirementsEn}
                    onChange={(event) => updateCourseField("requirementsEn", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "ماذا سيتعلم الطالب بالعربية" : "What Students Learn Arabic"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={courseForm.whatYouWillLearnAr}
                    onChange={(event) => updateCourseField("whatYouWillLearnAr", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "ماذا سيتعلم الطالب بالإنجليزية" : "What Students Learn English"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={courseForm.whatYouWillLearnEn}
                    onChange={(event) => updateCourseField("whatYouWillLearnEn", event.target.value)}
                  />
                </div>
              </div>

              <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">{isAr ? "الأقسام والدروس" : "Sections and lessons"}</h6>
                  <button type="button" className="btn btn-sm btn-outline-dark" onClick={addSection}>
                    {isAr ? "إضافة قسم" : "Add Section"}
                  </button>
                </div>

                {courseForm.sections.map((section, sectionIndex) => (
                  <div className="card border-0 shadow-sm mb-3" key={`section-${section.id || sectionIndex}`}>
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">
                          {isAr ? `القسم ${sectionIndex + 1}` : `Section ${sectionIndex + 1}`}
                        </h6>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeSection(sectionIndex)}
                          disabled={courseForm.sections.length === 1}
                        >
                          {isAr ? "حذف القسم" : "Remove Section"}
                        </button>
                      </div>

                      <div className="row g-3">
                        <div className="col-12 col-md-6">
                          <label className="form-label">{isAr ? "عنوان القسم بالعربية" : "Section Title Arabic"}</label>
                          <input
                            className="form-control"
                            value={section.titleAr}
                            onChange={(event) => updateSection(sectionIndex, "titleAr", event.target.value)}
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <label className="form-label">{isAr ? "عنوان القسم بالإنجليزية" : "Section Title English"}</label>
                          <input
                            className="form-control"
                            value={section.titleEn}
                            onChange={(event) => updateSection(sectionIndex, "titleEn", event.target.value)}
                          />
                        </div>
                      </div>

                      <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
                        <div className="fw-semibold">{isAr ? "الدروس" : "Lessons"}</div>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => addLesson(sectionIndex)}
                        >
                          {isAr ? "إضافة درس" : "Add Lesson"}
                        </button>
                      </div>

                      {section.lessons.map((lesson, lessonIndex) => (
                        <div className="border rounded-4 p-3 mb-3" key={`lesson-${lesson.id || lessonIndex}`}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="fw-semibold">
                              {isAr ? `الدرس ${lessonIndex + 1}` : `Lesson ${lessonIndex + 1}`}
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => removeLesson(sectionIndex, lessonIndex)}
                              disabled={section.lessons.length === 1}
                            >
                              {isAr ? "حذف الدرس" : "Remove Lesson"}
                            </button>
                          </div>

                          <div className="row g-3">
                            <div className="col-12 col-md-6">
                              <label className="form-label">{isAr ? "عنوان الدرس بالعربية" : "Lesson Title Arabic"}</label>
                              <input
                                className="form-control"
                                value={lesson.titleAr}
                                onChange={(event) => updateLesson(sectionIndex, lessonIndex, "titleAr", event.target.value)}
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <label className="form-label">{isAr ? "عنوان الدرس بالإنجليزية" : "Lesson Title English"}</label>
                              <input
                                className="form-control"
                                value={lesson.titleEn}
                                onChange={(event) => updateLesson(sectionIndex, lessonIndex, "titleEn", event.target.value)}
                              />
                            </div>
                            <div className="col-12 col-md-4">
                              <label className="form-label">{isAr ? "نوع الدرس" : "Lesson Type"}</label>
                              <select
                                className="form-select"
                                value={lesson.lessonType}
                                onChange={(event) => updateLesson(sectionIndex, lessonIndex, "lessonType", event.target.value)}
                              >
                                <option value="video">{isAr ? "فيديو" : "Video"}</option>
                                <option value="text">{isAr ? "نص" : "Text"}</option>
                                <option value="file">{isAr ? "ملف" : "File"}</option>
                                <option value="mixed">{isAr ? "مختلط" : "Mixed"}</option>
                              </select>
                            </div>
                            <div className="col-12 col-md-4">
                              <label className="form-label">{isAr ? "مدة الدرس بالثواني" : "Duration Seconds"}</label>
                              <input
                                type="number"
                                min="0"
                                className="form-control"
                                value={lesson.durationSeconds}
                                onChange={(event) => updateLesson(sectionIndex, lessonIndex, "durationSeconds", event.target.value)}
                              />
                            </div>
                            <div className="col-12 col-md-4 d-flex align-items-end">
                              <div className="form-check mb-2">
                                <input
                                  id={`lesson-preview-${sectionIndex}-${lessonIndex}`}
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={lesson.isPreview}
                                  onChange={(event) => updateLesson(sectionIndex, lessonIndex, "isPreview", event.target.checked)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`lesson-preview-${sectionIndex}-${lessonIndex}`}
                                >
                                  {isAr ? "متاح كمعاينة" : "Preview lesson"}
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <label className="form-label">{isAr ? "رابط الفيديو" : "Video URL"}</label>
                              <input
                                className="form-control"
                                value={lesson.videoUrl}
                                onChange={(event) => updateLesson(sectionIndex, lessonIndex, "videoUrl", event.target.value)}
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label">{isAr ? "محتوى الدرس بالعربية" : "Lesson Content Arabic"}</label>
                              <textarea
                                rows="2"
                                className="form-control"
                                value={lesson.contentAr}
                                onChange={(event) => updateLesson(sectionIndex, lessonIndex, "contentAr", event.target.value)}
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label">{isAr ? "محتوى الدرس بالإنجليزية" : "Lesson Content English"}</label>
                              <textarea
                                rows="2"
                                className="form-control"
                                value={lesson.contentEn}
                                onChange={(event) => updateLesson(sectionIndex, lessonIndex, "contentEn", event.target.value)}
                              />
                            </div>
                            <div className="col-12">
                              <label className="form-label">{isAr ? "رابط أو مرجع الملف" : "Attachment Path"}</label>
                              <input
                                className="form-control"
                                value={lesson.attachmentPath}
                                onChange={(event) => updateLesson(sectionIndex, lessonIndex, "attachmentPath", event.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex gap-2 mt-3">
                <button className="btn btn-dark" type="submit" disabled={savingCourse}>
                  {savingCourse
                    ? isAr
                      ? "جارٍ الحفظ..."
                      : "Saving..."
                    : courseForm.id
                      ? isAr
                        ? "تحديث وإعادة إرسال"
                        : "Update and Resubmit"
                      : isAr
                        ? "إرسال الكورس"
                        : "Submit Course"}
                </button>
                {courseForm.id ? (
                  <button className="btn btn-outline-secondary" type="button" onClick={resetCourseForm}>
                    {isAr ? "إلغاء" : "Cancel"}
                  </button>
                ) : null}
              </div>
            </form>

            <hr className="my-4" />

            {courses.length === 0 ? (
              <div className="text-muted">
                {isAr ? "لا توجد كورسات مضافة حتى الآن." : "No courses have been submitted yet."}
              </div>
            ) : isMobile ? (
              <div className="provider-center__mobile-list">
                {courses.map((course) => (
                  <article className="provider-center__mobile-item" key={course.id}>
                    <div className="provider-center__mobile-head">
                      <div>
                        <div className="fw-semibold">
                          {course.titleEn || course.titleAr || `#${course.id}`}
                        </div>
                        <div className="small text-muted">
                          {formatMoney(course.salePrice > 0 ? course.salePrice : course.price)}
                          {course.rejectionReason ? ` · ${course.rejectionReason}` : ""}
                        </div>
                      </div>
                      <span className={`badge rounded-pill ${getStatusBadgeClass(course.approvalStatus)}`}>
                        {getStatusLabel(course.approvalStatus, isAr)}
                      </span>
                    </div>
                    <div className="provider-center__mobile-grid">
                      <div>
                        <div className="small text-muted">{isAr ? "الأقسام" : "Sections"}</div>
                        <div>{course.sections.length}</div>
                      </div>
                      <div>
                        <div className="small text-muted">{isAr ? "الاشتراكات" : "Enrollments"}</div>
                        <div>{course.enrollmentsCount}</div>
                      </div>
                    </div>
                    <div className="provider-center__mobile-actions">
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleEditCourse(course)}>
                        {isAr ? "تعديل" : "Edit"}
                      </button>
                      <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteCourse(course)}>
                        {isAr ? "حذف" : "Delete"}
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>{isAr ? "الكورس" : "Course"}</th>
                      <th>{isAr ? "الحالة" : "Approval"}</th>
                      <th>{isAr ? "السعر" : "Price"}</th>
                      <th>{isAr ? "الاشتراكات" : "Enrollments"}</th>
                      <th>{isAr ? "الإجراءات" : "Actions"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {courses.map((course) => (
                      <tr key={course.id}>
                        <td>
                          <div className="fw-semibold">
                            {course.titleEn || course.titleAr || `#${course.id}`}
                          </div>
                          <div className="small text-muted">
                            {(isAr ? course.shortDescriptionAr : course.shortDescriptionEn) ||
                              course.rejectionReason ||
                              course.slug}
                          </div>
                        </td>
                        <td>
                          <span className={`badge rounded-pill ${getStatusBadgeClass(course.approvalStatus)}`}>
                            {getStatusLabel(course.approvalStatus, isAr)}
                          </span>
                        </td>
                        <td>{formatMoney(course.salePrice > 0 ? course.salePrice : course.price)}</td>
                        <td>{course.enrollmentsCount}</td>
                        <td>
                          <div className="d-flex gap-2 flex-wrap">
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleEditCourse(course)}>
                              {isAr ? "تعديل" : "Edit"}
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteCourse(course)}>
                              {isAr ? "حذف" : "Delete"}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
